import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { FC, useState } from "react";
import { capitalizeFirstLetter, generateSlug } from "../../helpers/format";
import { FormikErrors, FormikTouched } from "formik";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useParams, useLocation } from "react-router-dom";

type IProps = {
  name: string;
  values: any;
  type: string;
  label?: string;
  error?:
  | string
  | FormikErrors<any>
  | string[]
  | FormikErrors<any>[]
  | undefined;
  touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
  handleChange: (value: any) => void;
  handleBlur?: (value: any) => void;
  inputProps?: any;
  isForm?: boolean;
  isSlugify?: boolean;
  slugDependencies?: {
    label: string;
    key: string;
    hasApiCall: boolean;
    func: (value: string) => Promise<any>;
  }[];
  completeData?: any;
  disabled?: boolean;
  onKeyDown?: (event: any) => void;
  hideBtnOnEdit?: boolean;
  shouldDisableSlug?: boolean;
  helperText?: string;
};

const InputField: FC<IProps> = ({
  name,
  type = "text",
  values,
  touched,
  handleChange,
  handleBlur,
  error,
  label,
  inputProps = {},
  isForm = false,
  isSlugify = false,
  slugDependencies,
  completeData,
  disabled = false,
  onKeyDown,
  hideBtnOnEdit = false,
  shouldDisableSlug = false,
  helperText,
}) => {
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const pagesWithSlugDisabled = ["article", "web_stories","loans24"];
  const isSlugDisabledPage = pagesWithSlugDisabled.some((page) => location.pathname.includes(page));

  return (
    <>
      <TextField
        className={disabled ? "bg-gray-300 w-full" : "w-full"}
        id="outlined-basic"
        label={label}
        error={(error && touched) as boolean}
        variant="outlined"
        name={name}
        helperText={helperText}
        disabled={loading || disabled || (!!params.id && name === "slug" && !isSlugDisabledPage)}
        onKeyDown={(e) => {
          if (onKeyDown) {
            onKeyDown(e);
          }
        }}
        value={
          loading
            ? "loading ..."
            : values !== null
              ? values !== undefined
                ? values
                : ""
              : ""
        }
        onChange={(e: any) => {
          handleChange(e);
        }}
        onBlur={(e: any) => {
          handleBlur && handleBlur(e);
        }}
        type={type}
        InputProps={{
          ...inputProps,
          endAdornment: isSlugify && (!hideBtnOnEdit || !params.id) ? (
            <InputAdornment position="end">
              <Tooltip
                title={`To auto generate slug please fill the following data in the form before proceeding : ${slugDependencies &&
                  slugDependencies.map((item: any) => item.label).join(", ")
                  }`}
              >
                <IconButton
                  onClick={() => {
                    setLoading(true);
                    generateSlug({
                      completeData,
                      slugDependencies,
                      setValue: (value: string) => {
                        handleChange({ target: { value } });
                        setLoading(false);
                      },
                      onBreak: () => {
                        setLoading(false);
                      },
                    });
                  }}
                >
                  <RefreshIcon />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ) : undefined,
        }}
        InputLabelProps={{ shrink: true }}
        placeholder="Enter required value here"
      />
      {touched && error && (
        <p className="text-red-600 text-sm mb-2">
          {capitalizeFirstLetter(error as string)}
        </p>
      )}
    </>
  );
};

export default InputField;
